<template>
  <ul class="tenant-provider-manager uk-list">
    <li
      :key="index"
      class="tenant-provider-manager__entry"
      v-for="(providerStatus, index) in providerStatuses"
    >
      <checkbox
        :disabled="isSubmitting"
        :label="getProviderName(providerStatus.provider)"
        :value="providerStatus.enabled"
        @click.native.prevent="maybeToggleProvider(index)"
      />
    </li>
  </ul>
</template>

<script>
import { cloneDeep, pick } from 'lodash';
import UIkit from 'uikit';
import Checkbox from '@/components/Checkbox';
import toggleProviderMutation from '@/api/mutations/toggle-provider.graphql';

export default {
  name: 'tenant-provider-manager',
  components: {
    Checkbox,
  },
  props: {
    tenant: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSubmitting: false,
      providerStatuses: null,
    };
  },
  watch: {
    tenant: {
      handler(tenant) {
        if (tenant.providerStatuses) {
          this.providerStatuses = cloneDeep(tenant.providerStatuses);
        } else {
          this.providerStatuses = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getProviderName(provider) {
      return this.$t(`providers.${provider}`);
    },
    async maybeToggleProvider(index) {
      const status = this.providerStatuses[index];
      const i18nKey = status.enabled ? 'disable' : 'enable';

      const message = this.$t(`confirmations.${i18nKey}`, {
        provider: this.getProviderName(status.provider),
      });

      try {
        await UIkit.modal.confirm(message);
        this.toggleProvider(index);
      } catch (error) {
        // do nothing
      }
    },
    async toggleProvider(index) {
      this.isSubmitting = true;

      const status = this.providerStatuses[index];
      status.enabled = !status.enabled;

      try {
        const response = await this.$apollo.mutate({
          mutation: toggleProviderMutation,
          variables: {
            ...status,
            tenantId: this.tenant.id,
          },
        });

        const newStatus =
          pick(response.data.toggleProvider, ['provider', 'enabled']);

        this.providerStatuses[index] = newStatus;
        this.$emit('change', newStatus);
        this.isSubmitting = false;
      } catch (e) {
        this.isSubmitting = false;
        throw e;
      }
    },
  },
  i18n: {
    messages: {
      de: {
        confirmations: {
          enable: 'Provider "{provider}" wirklich aktivieren?',
          disable: 'Provider "{provider}" wirklich deaktivieren?',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// TenantProviderManager.vue?8f13f5c2